import z from 'zod';

import {
  ACCEPTED_UPLOAD_MIMES,
  isAcceptedUploadMime,
  maxBytesFor,
} from '@virtual-care/media-isomorphic';

export const ACCEPTED_MIME_TYPES = ACCEPTED_UPLOAD_MIMES;

export const files = z
  .array(z.instanceof(File))
  .optional()
  .refine(
    (files) => !files || files.every((file) => isAcceptedUploadMime(file.type)),
    {
      message: 'i18n:shared.validation.fileMimeNotSupported',
    },
  )
  .refine(
    (files) =>
      !files ||
      files.every((file) => {
        if (!isAcceptedUploadMime(file.type)) return true;
        return file.size <= maxBytesFor(file.type);
      }),
    {
      message: 'i18n:shared.validation.fileSizeExceeded',
    },
  );
